import { Auth }from "../context/AuthProvider";

export function isAuthenticated(auth: Auth) {
  return auth.email && (Date.now()/1000 < auth.exp);
}
